import { basicInitialState } from 'store/_utils/basicInitialState';
import { TFarmsState } from './farms';

export const farmsInitialState: TFarmsState = {
  ...basicInitialState,
  farms: [],
  searchText: ''
};
